import { siteWide } from '@helpers/grid';
import styled from 'styled-components';
const Container = styled.section `
  scroll-margin: var(--headerHeight) 0 0;

  &[data-flush='top'] {
    --sectionSpacingTop: 0;
  }

  &[data-flush='bottom'] {
    --sectionSpacingBottom: 0;
  }

  &[data-flush='both'],
  .page-section & {
    --sectionSpacingTop: 0;
    --sectionSpacingBottom: 0;
  }

  &:has([class]) {
    background-color: var(--bgColor);
    color: var(--fgColor);

    .page-section:has(.section-illustration img) & {
      background-color: transparent;
    }
  }
`;
const Inner = styled.div `
  ${siteWide};

  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);

  .page-container & {
    --sitePadding: 0;
  }

  [data-narrow='true'] & {
    --siteWidth: var(--siteWidthNarrow);
  }
`;
const SectionWrapperStyles = {
    Container,
    Inner,
};
export default SectionWrapperStyles;
